import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { ReportService } from '../../pages/report/report.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-report-stock-point',
  templateUrl: './report-stock-point.component.html',
  styleUrls: ['./report-stock-point.component.scss'],
})
export class ReportStockPointComponent implements OnInit {


  @Input() customerId: any;
  @Input() customerName:any;
  @Input() month: any;
  @Input() year: any;
  @Input() type :any;
  @Input() earlyStock: any;
  @Input() endStock: any;
  
  token: any;
  stockMutationData: any[] = [];
  title : any;
  showEarlyStock : boolean =false;
  showEndStock : boolean = false;
  showInStock : boolean = false;
  showOutStock : boolean = false;
  inStock: number=0;
  outStock: number=0;
  constructor(
    public modalController: ModalController,
    private storage: Storage,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private utilService: UtilService,
    private reportService: ReportService) { }

  ngOnInit() {
    this.storage.get('user_token')
    .then((token) => {
      if(token) {
        this.token = token;
        this.title = '';
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  getData() {
    let options = {
      "token": this.token,
      "customer_id": this.customerId,
      "month": this.month,
      "year": this.year,
      "type": this.type
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      if(this.type=='I'){
        this.title = 'Masuk';
        this.showInStock = true;
      }
      else if(this.type=='O'){
        this.title = 'Keluar';
        this.showOutStock = true;
      }
      else{
        this.showEarlyStock = true;
        this.showEndStock = true;
        this.showInStock = true;
        this.showOutStock = true;
      }
      this.reportService.getMutationPointStock(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.stockMutationData = response.results;
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }

  async dismissModal() {
    const close: string = "Modal Removed";
    await this.modalController.dismiss(close);
  }
get totalIn(): number {
  return this.stockMutationData
    .filter(item => item.point_mutation_type_id === 'I' || item.point_mutation_type_id === 'V')
    .reduce((sum, item) => sum + Number(item.point || 0), 0);
}

get totalOut(): number {
  return this.stockMutationData
    .filter(item => item.point_mutation_type_id === 'O' || item.point_mutation_type_id === 'VP')
    .reduce((sum, item) => sum + Number(item.point || 0), 0);
}

}
